(() => {
  if (window.QeDescription?.init) {
    window.QeDescription.init(document);
    return;
  }

  const HEADING = /^H[1-6]$/;
  const SPEC_HEADING = /^\s*(?:especificaciones?(?:\s+t[eé]cnicas?)?|dimensiones?|medidas?(?:\s+generales?)?|ficha\s+t[eé]cnica|datos?\s+t[eé]cnicos?|detalles?\s+t[eé]cnicos?|informaci[oó]n\s+t[eé]cnica)\s*:?\s*$/i;
  const DIMENSION_VALUE = /(?:^|[.;]\s*)(?:medidas?|dimensiones?)(?:\s*\([^)]*\))?\s*:\s*\d+(?:[.,]\d+)?(?:\s*[×x]\s*\d+(?:[.,]\d+)?)*\s*(?:mm|cm|m|metros?|kg)\b|(?:largo|ancho|alto|altura|profundidad|di[aá]metro|peso|carga\s+m[aá]xima)(?:\s+(?:del?|de\s+la|total|neto|neta|m[aá]ximo|m[aá]xima|asiento|respaldo)){0,4}\s*:?\s*(?:Ø\s*)?\d+(?:[.,]\d+)?\s*(?:mm|cm|m|metros?|kg)\b|\d+(?:[.,]\d+)?(?:\s*[×x]\s*\d+(?:[.,]\d+)?)+\s*(?:mm|cm|m|metros?)\b|\d+(?:[.,]\d+)?\s*(?:mm|cm|m|metros?|kg)\s+de\s+(?:largo|ancho|alto|altura|profundidad|di[aá]metro|peso)\b/i;

  function plan(blocks) {
    const about = { title: 'Descripción', items: [] };
    const specifications = { title: 'Especificaciones', items: [] };
    let section = about;

    blocks.forEach((block, index) => {
      const text = (block.text || '').trim();
      if (HEADING.test(block.tag) && SPEC_HEADING.test(text)) {
        section = specifications;
        return;
      }
      if (HEADING.test(block.tag)) {
        section.items.push(index);
      } else if (block.tag === 'TABLE' || DIMENSION_VALUE.test(text)) {
        specifications.items.push(index);
      } else {
        section.items.push(index);
      }
    });

    return { groups: [about, specifications] };
  }

  function apply(container) {
    if (container.hasAttribute('data-qe-ready')) return;
    const nodes = [...container.childNodes];

    const result = plan(nodes.map((node) => ({
      tag: node.nodeType === 1 ? node.tagName : (node.nodeType === 3 ? '#TEXT' : '#NODE'),
      text: node.textContent || '',
    })));
    if (!result.groups.length) {
      container.setAttribute('data-qe-ready', '');
      return;
    }

    const wrapper = document.createElement('div');
    wrapper.className = 'qe-details';
    result.groups.forEach((group) => {
      const details = document.createElement('details');
      const summary = document.createElement('summary');
      summary.textContent = group.title;
      const body = document.createElement('div');
      body.className = 'qe-details__body';
      group.items.forEach((index) => body.appendChild(nodes[index]));
      details.append(summary, body);
      wrapper.appendChild(details);
    });

    container.replaceChildren(wrapper);
    container.setAttribute('data-qe-ready', '');
  }

  function init(root = document) {
    const containers = root.matches?.('[data-qe-collapsible]')
      ? [root]
      : [...(root.querySelectorAll?.('[data-qe-collapsible]') || [])];
    containers.forEach(apply);
  }

  window.QeDescription = { plan, init };
  document.addEventListener('click', (event) => {
    const jump = event.target.closest?.('[data-qe-description-jump]');
    if (!jump) return;
    const target = document.querySelector(jump.getAttribute('href'));
    const details = target?.querySelector('details');
    if (!details) return;
    event.preventDefault();
    details.open = true;
    details.scrollIntoView({ behavior: 'auto', block: 'start' });
    details.querySelector('summary')?.focus({ preventScroll: true });
  });
  document.addEventListener('shopify:section:load', (event) => init(event.target));
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => init(document));
  } else {
    init(document);
  }
})();
